import AmbientLight, { GameAmbientLight } from '../../e.elements/AmbientLight/AmbientLight'
import AnimationController from '../../d.controllers/AnimationController/AnimationController'
import LevelManager from '../../c.managers/LevelManager/LevelManager'
import TerrainManager from '../../d.controllers/TerrainController/TerrainController'
import DirectionalLight from '../../e.elements/DirectionalLight/DirectionalLight'
import { Environment, OrbitControls, SpotLight } from '@react-three/drei'
import { Suspense, useEffect, useState } from 'react'
import BattleManager from '../../d.controllers/BattleController/BattleController'
import { EffectComposer, Vignette } from '@react-three/postprocessing'
import { BlendFunction } from 'postprocessing'
import CharactersController from '../../d.controllers/CharactersController/CharactersController'
import ScreenNav from '../../d.controllers/HUD/ScreensNav'
import config from '../LevelTestScene/levelConfig'
import HUDController from '../../d.controllers/HUD/HUD'
import { useSceneStore } from './store'
import { addEventListener, dispatch, EVENTS_GAME, once } from '../../b.providers/EventsProvider/EventsProvider'
import AudioController from '../../d.controllers/AudioController/AudioController'
import AssetsManager from '../../c.managers/AssetsManager/AssetsManager'
import { Audio } from '../../d.controllers/AudioController'
import { CHARACTER_TYPES } from '../../f.assets/Characters/scripts/constants'
import { useScenesStore } from '../../b.providers/ScenesProvider/store'
import { BATTLE_STATES } from '../../c.managers/LevelManager/store.d'
import { SEL_LEVEL_SUMMARY } from '../../c.managers/TerrainManager/selectors'
import { SEL_CURRENT_LEVEL_CONFIG } from '../../b.providers/ScenesProvider/selectors'
import LoadingScreen from '../../d.controllers/HUD/LoadingScreen'

const GameSceneElements = () => {
  const [bootLevel, setBootLevel] = useState<boolean>()
  const config = useScenesStore(SEL_CURRENT_LEVEL_CONFIG)

  return (
    <>
      
      <AssetsManager
        loadingIndicator={<LoadingScreen />}
        assets={{
          menuScore: `${process.env.PUBLIC_URL}/assets/sfx/menu-score.mp3`,
          battleScore: `${process.env.PUBLIC_URL}/assets/sfx/battle-score.mp3`,
          punch1: `${process.env.PUBLIC_URL}/assets/sfx/punch-1.mp3`,
          punch2: `${process.env.PUBLIC_URL}/assets/sfx/punch-2.mp3`,
          punch3: `${process.env.PUBLIC_URL}/assets/sfx/punch-3.mp3`,
          voicePunch1: `${process.env.PUBLIC_URL}/assets/sfx/voice-punch-1.mp3`,
          voicePunch2: `${process.env.PUBLIC_URL}/assets/sfx/voice-punch-2.mp3`,
          voicePunch3: `${process.env.PUBLIC_URL}/assets/sfx/voice-punch-3.mp3`,
          voicePunch4: `${process.env.PUBLIC_URL}/assets/sfx/voice-punch-4.mp3`,
          voiceLaugh: `${process.env.PUBLIC_URL}/assets/sfx/voice-laugh.wav`,
          whoosh1: `${process.env.PUBLIC_URL}/assets/sfx/minion-whoosh-1.mp3`,
          magicThrown: `${process.env.PUBLIC_URL}/assets/sfx/magic-thrown.wav`,
          magicThrownAndHit: `${process.env.PUBLIC_URL}/assets/sfx/magic-thrown_and_hit.wav`,
          howl: `${process.env.PUBLIC_URL}/assets/sfx/howl.mp3`,
          jackLaugh: `${process.env.PUBLIC_URL}/assets/sfx/jack-laugh.mp3`,
          witchLaugh: `${process.env.PUBLIC_URL}/assets/sfx/witchy-laugh.mp3`,
          coloredBG: `${process.env.PUBLIC_URL}/assets/images/theme/blurry-gradient-haikei.png`,
          window: `${process.env.PUBLIC_URL}/assets/images/theme/window.svg`,
          header: `${process.env.PUBLIC_URL}/assets/images/theme/header.svg`,
        }}
      >
        <AudioController />
        {/* <GameAmbientLight /> */}
        <MainRules levelSwitch={setBootLevel} />

        {bootLevel && (
          <>
            <CharactersController />
            <AnimationController />
            <TerrainManager />
            <BattleManager />
            <HUDController />
            <LevelManager levelConfig={config} />
          </>
        )}

        {/* <DirectionalLight color={'yellow'} position={[0, 10, 0]} castShadow intensity={0.5} /> */}
        {/* <DirectionalLight color={'#7FFFD4'} position={[0, 5, 0]} castShadow intensity={0.25} /> */}
        {/* <pointLight args={[color, 5, 17]} position={lightPosition} /> */}
        <DirectionalLight color={'#7FFFD4'} position={[0, 10, 0]} castShadow intensity={0.5} />
        <ambientLight intensity={0.25} />
        <Suspense fallback={null}>
          <Environment
            // preset="night"
            files={`${process.env.PUBLIC_URL}/assets/hdr/gym_entrance_4k.hdr`}
            background={false}
          />
        </Suspense>
      </AssetsManager>
    </>
  )
}

export default GameSceneElements

const MainRules = ({ levelSwitch }: { levelSwitch: (val: boolean) => void }) => {
  const [bootLevel, setBootLevel] = useState<boolean>()
  const [initialPage, setInitialPage] = useState<string>('/index')
  const startBattle = useSceneStore(s => s.levels.startBattle)
  const battleState = useSceneStore(s => s.levels.data.battleState)
  const currentLevelId = useScenesStore(s => s.user.currentLevelId)
  const clearGameElement = useScenesStore(s => s.clearGameElement)
  const updateUser = useScenesStore(s => s.updateUser)
  const resetCharacters = useSceneStore(s => s.characters.resetCharacters)
  const resetLevel = useSceneStore(s => s.levels.resetLevel)
  const resetTerrain = useSceneStore(s => s.terrain.resetTerrain)
  const levelResult = useSceneStore(SEL_LEVEL_SUMMARY)

  useEffect(() => {
    setTimeout(() => setBootLevel(true), 500)
    // setTimeout(() => setInitialPage('/results'), 2000)
    const unsub = addEventListener(EVENTS_GAME.MENU_DISMISS, () => {
      setInitialPage('')
      startBattle()
      Audio.enterToBattle()
    })
    return () => {
      unsub()
    }
  }, [])

  const TIME_TO_DISPLAY_RESULTS = 500
  useEffect(() => {
    if (battleState === BATTLE_STATES.ENDED && levelResult) {
      setTimeout(() => {
        // resolve result
        setInitialPage('/results')
        setTimeout(() => {
          setBootLevel(false)
        }, TIME_TO_DISPLAY_RESULTS)
      }, 4000)
    }
  }, [battleState, levelResult])
  useEffect(() => {
    if (!bootLevel && initialPage === '/results') {
      // unmount components from parent
      levelSwitch(false)
      // guess amount finish, then clear states
      setTimeout(() => {
        // clear stores
        resetCharacters()
        resetLevel()
        resetTerrain()
        clearGameElement()

        const levelKey = currentLevelId as string
        const levelNum = Number(levelKey.replace('level', ''))
        let nextLevelId = currentLevelId // same level
        if (levelResult.diff > 0) {
          // next level
          nextLevelId = `level${levelNum + 1}`
        }
        if (levelNum < 5) {
          updateUser({ currentLevelId: nextLevelId })
        } else {
          // game finished
          updateUser({ currentLevelId: '' })
        }

        // reboot level
        setTimeout(() => {
          setBootLevel(true)
        }, 400)
      }, 200)
    }
    levelSwitch(bootLevel as boolean)
  }, [bootLevel, initialPage])

  return <ScreenNav initialPage={initialPage} />
}
